import sliceCreator from '../../index.js';
import {PROFILE} from '../../../constants/index.js';
const _updateProfileAction = sliceCreator('PROFILE',PROFILE, 'patch');

const { asyncAction: updateProfileAction, reducer, clearData: clearupdateProfileAction } = _updateProfileAction;

export default reducer;

export {
    updateProfileAction,
    clearupdateProfileAction
}


